import { Link } from "react-router-dom";

/* SAMPLE DATA */
import navMenu from "../../data/navigation";

/* ASSETS */
import Logo from "../../assets/images/logo.png";
import { useSelector } from "react-redux";

const Sidebar = () => {
  var pathname = window.location.pathname;

  const userDetails = useSelector((state) => state?.user);

  return (
    <section className="h-screen w-sidebar bg-[#141518] transition-all duration-300 ease-linear">
      {/* HEADER */}
      <div className="h-auto border-b border-white border-opacity-20 px-5 py-3 flex items-start text-start">
        <img
          src={Logo}
          className="w-auto h-16 object-contain text-start "
          alt="LIBF"
        />
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="h-[90vh] flex flex-col gap-0">
        {/* LIBF 2025 */}
        {userDetails?.user?.firstName !== "Startup" && (
          <div className="p-2">
            <h5 className="px-3 pt-3 pb-2 text-sm font-ibm-regular text-white text-opacity-50">
              LIBF 2025
            </h5>
            {navMenu.slice(0, 4).map((nav) => (
              <Link
                to={nav.link}
                key={nav.id}
                className={`w-full group flex items-center gap-3 mt-2 px-3 py-2.5 ${pathname ===
                  nav.link && "bg-white/10 rounded-md"}`}
              >
                <nav.icon
                  className={`w-5 h-5 text-sidebarText ${pathname ===
                    nav.link &&
                    "text-white"} group-hover:text-white transition-all duration-300 ease-in-out`}
                />
                <div>
                  <p
                    className={`text-sm font-ibm-semibold text-sidebarText ${pathname ===
                      nav.link &&
                      "text-white"} group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
                  >
                    {nav.name}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* LIBF 2026 */}
        {userDetails?.user?.firstName !== "Startup" && (
          <div className="p-2">
            <h5 className="px-3 pt-3 pb-2 text-sm font-ibm-regular text-white text-opacity-50">
              LIBF 2026
            </h5>
            {navMenu.slice(4, 7).map((nav) => (
              <Link
                to={nav.link}
                key={nav.id}
                className={`w-full group flex items-center gap-3 mt-2 px-3 py-2.5 ${pathname ===
                  nav.link && "bg-white/10 rounded-md"}`}
              >
                <nav.icon
                  className={`w-5 h-5 text-sidebarText ${pathname ===
                    nav.link &&
                    "text-white"} group-hover:text-white transition-all duration-300 ease-in-out`}
                />
                <div>
                  <p
                    className={`text-sm font-ibm-semibold text-sidebarText ${pathname ===
                      nav.link &&
                      "text-white"} group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
                  >
                    {nav.name}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* LSC WEBSITE */}
        <div className="p-2">
          <h5 className="px-3 pt-3 pb-2 text-sm font-ibm-regular text-white text-opacity-50">
            STARTUP CELL
          </h5>
          {navMenu.slice(7, 9).map((nav) => (
            <Link
              to={nav.link}
              key={nav.id}
              className={`w-full group flex items-center gap-3 mt-2 px-3 py-2.5 ${pathname ===
                nav.link && "bg-white/10 rounded-md"}`}
            >
              <nav.icon
                className={`w-5 h-5 text-sidebarText ${pathname === nav.link &&
                  "text-white"} group-hover:text-white transition-all duration-300 ease-in-out`}
              />
              <div>
                <p
                  className={`text-sm font-ibm-semibold text-sidebarText ${pathname ===
                    nav.link &&
                    "text-white"} group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
                >
                  {nav.name}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
